module.exports = __webpack_public_path__ + "img/制御工学3_1_1.f7b45057.png";